import React from 'react';
import classNames from 'classnames';
import { CardData } from '..';
import useTranslation from '../../../../../../../hooks/useTranslation';
import BrandLogo from '../../../../../../hoc/components/logo/logo';
import { NovartisPatientSupporSplitSVG } from '../../../../../../../assets/images/novartisPatientSupportsplit';
import { NovartisCopayPlusSVG } from '../../../../../../../assets/images/novartisCopayPlusSvg';
import useProduct from '../../../../../../../hooks/useProduct';

const EcdCard: React.FC<{
	data: CardData;
	printMode?: boolean;
}> = ({ data, printMode = false }) => {

	const { t } = useTranslation();
	const { params } = useProduct();

	return (
		<div className="flex flex-col border border-novartis-font font-novartis max-w-sm w-full pb-1">
			<div className="flex p-4">
				<div className="max-w-36">
					<BrandLogo />
				</div>
			</div>
			<div
				className={classNames('flex gap-3 justify-center items-center p-4', {
					'bg-brand text-font-contrast': !printMode,
					'bg-none text-novartis-font': printMode,
				})}>
				<div className="flex">
					<p className="self-start text-2xl font-bold">{params.currency}</p>
					<p className="text-6xl font-bold">{params.cardOffer}</p>
				</div>
				<div className="">
					<NovartisCopayPlusSVG
						className={classNames('', {
							'fill-font-contrast': !printMode,
							'fill-novartis-font': printMode,
						})}
					/>
				</div>
			</div>
			<div className="flex flex-col gap-5 p-5">
				<div className="flex flex-col gap-2 text-sm">
					<div className="flex flex-col text-left gap-1.5">
						<div className="flex gap-1.5">
							<div className="font-bold">
								{t('pages.confirmation.card.bin')}:
							</div>
							<div>{data.bin}</div>
						</div>
						<div className="flex gap-1.5">
							<div className="font-bold">
								{t('pages.confirmation.card.pcn')}:
							</div>
							<div>{data.pcn}</div>
						</div>
						<div className="flex gap-1.5">
							<div className="font-bold">
								{t('pages.confirmation.ecdCard.grp')}:
							</div>
							<div>{data.group}</div>
						</div>
						<div className="flex gap-1.5">
							<div className="font-bold">
								{t('pages.confirmation.ecdCard.id')}:
							</div>
							<div>{data.memberId}</div>
						</div>
					</div>
				</div>
				<div className="flex self-end">
					<NovartisPatientSupporSplitSVG />
				</div>
			</div>
			<div className="bg-repeat-round w-full h-6 bg-[length:4%] bg-novartis-singlechain"></div>
		</div>
	);
};

export default EcdCard;
